export const sizeComparisonOptions = [
  { value: 'larger', displayValue: 'Greater Than' },
  { value: 'smaller', displayValue: 'Less Than' },
  { value: 'between', displayValue: 'Between' },
];

export const sizeTypeOptions = [
  { value: 'MB', displayValue: 'MB' },
  { value: 'KB', displayValue: 'KB' },
  { value: 'Byte', displayValue: 'Byte' },
];
